import ampoule from '../img/Ampoule Bleu.svg'

const typeToDisplay = {
    'motoecole':'moto-école',
    'concessionnaire':'concession'
}

const renderAffiliate = (p) => {
    const {affiliate,sponsor} = p
    return <div className="headtitle">
        Vous avez été recommandé <br/>par notre
        partenaire<br/><b>{affiliate.prenom} {affiliate.nom}</b><br/>de la {typeToDisplay[sponsor.type]} {sponsor.nom}
    </div>
}

const renderDefault = (p) => <div className="headtitle">
    Bienvenue sur <b>ASSUR BON PLAN,</b><br/>
    où l'assurance de votre {p.type}<br/>
    se fait en 3 clics !
    </div>


export default (p) => {
    return <div className="blueheader">
        <div>
            { p.affiliate.login ? renderAffiliate(p) : renderDefault(p) }
            {/*
            <div className="ideabox">
                <img src={ampoule}/>
                <b>Innovation 2024 ! </b><br/>
                Assur Bon Plan lance le <br/>
                <b>PREMIER comparateur</b> <br/>
                d'assurance deux roues pour les concessionnaires !
            </div>
            */}
        </div>
    </div>
}